import React from 'react';

const PollQuestionGridView = () => {
    return (
        <></>
    )
}

export default PollQuestionGridView;